export class Link {
    id: string;
    link: string;
    text: string;
    roles: {};
}
